import Vue from 'vue'
import axios from 'axios'
export function getTime() {
  var date = new Date();//获取系统当前时间
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  var d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  var day = date.getDay();//系统时间中的星期值
  var weeks = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
  var w = weeks[day];//显示为星期几
  var h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  var minute = date.getMinutes();
  minute = minute < 10 ? ('0' + minute) : minute;
  var seconds = date.getSeconds();
  seconds = seconds < 10 ? ('0' + seconds) : seconds;
  return y + '-' + m + '-' + d + ' ' + w + ' ' + h + ':' + minute + ':' + seconds;
}
export const isObject = obj => {
  return obj !== null && typeof obj === "object";
};

export const isArray = obj => {
  return Array.isArray(obj);
};

export const hasClass = (ele, cName) => {
  return !!ele.className.match(new RegExp( "(\\s|^)" + cName + "(\\s|$)"))
}

export const addClass = (ele, cName) => {
  if (!hasClass(ele, cName)) {
    ele.className += " " + cName;
  }
}

export const removeClass = (ele, cName) => {
  if( hasClass( ele, cName ) ){
    ele.className = ele.className.replace( new RegExp( "(\\s|^)" + cName + "(\\s|$)" )," " ); // replace方法是替换
  }
}

export const copyProps =  (arr, addProp, referProp) => {
  if (!arr.length) return []
  arr.forEach(ele => {
    ele[addProp] = ele[referProp]
    if (ele.children) {
      copyProps(ele.children, addProp, referProp)
    }
  });
  return arr 
}

export const getZhOrg = (row,column,cellValue) => {
  if(null==cellValue){
    return ''
  }
  var org = cellValue
  var orgLevel = org.ext03
  if(orgLevel == 4){ //所属机构级别为网点
    if(org.org&&org.org.ext03==3){ //上级机构为支行
      return org.org.orgName;
    }
  }else if(orgLevel == 3){
    return org.orgName;
  }
  return ''
}

export const getFhOrg = (row,column,cellValue) => {
  if(null==cellValue){
    return ''
  }
  var org = cellValue
  var orgLevel = org.ext03
  if(orgLevel == 4){ //所属机构级别为网点
    if(org.org&&org.org.org&&org.org.org.ext03==2){ //上两级机构为支行
      return org.org.org.orgName;
    }
  }else if(orgLevel == 3){
    if(org.org&&org.org.ext03==2)
    return org.org.orgName;
  }else if(orgLevel == 2){
    return org.orgName;
  }
  return ''
}


// WEBPACK FOOTER //
// ./src/common/utils/CommonFn.js